/* eslint-disable */
import searchService from "../services/search-service";
export default {
    state: {
        cities: [],
        categories: [],
        selectedCategory: null,
        selectedCity: null,
    },
    mutations: {
        updateCities(state, cities) {
            state.cities = cities;
        },
        updateCategories(state, categories) {
            state.categories = categories;
        },
        selectCity(state, {
            id
        }) {
            state.selectedCity = id
        },
        selectCategory(state, {
            id
        }) {
            state.selectedCategory = id
        }
    },
    actions: {
        async getLookups(context) {
            var response = await searchService.getLookups();
            context.commit("updateCities", response.data.cities);
            context.commit("updateCategories", response.data.categories);
        },
        selectCity(context, id) {
            context.commit("selectCity", {
                id
            });
        },
        selectCategory(context, id) {
            context.commit("selectCategory", {
                id
            });
        }
    }

}